import React from 'react'
import { Text } from 'react-native'
import { captureException } from 'utils/sentry'

type Props = {}
type State = { hasError: boolean }

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any) {
    captureException(error)
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return <Text>Loading failed! Please reload.</Text>
    }

    return this.props.children
  }
}

export default ErrorBoundary
